import { render, staticRenderFns } from "./AnnexReportTable.vue?vue&type=template&id=5fbde884&scoped=true"
import script from "./AnnexReportTable.vue?vue&type=script&lang=js"
export * from "./AnnexReportTable.vue?vue&type=script&lang=js"
import style0 from "./AnnexReportTable.vue?vue&type=style&index=0&id=5fbde884&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbde884",
  null
  
)

export default component.exports